/**
 * Created by xupengwei on 2018/6/26.
 * Modified by heyushuang on 2019/9/26.
 */
export default {
  getOs: (state) => {
    return state.os.toLowerCase();
  },
  getImgpre: (state) => {
    return state.imgPre;
  },
  getScheme: (state) => {
    return state.scheme;
  }
};




// WEBPACK FOOTER //
// ./src/store/getters.js